/**
 * SpectrumVisualizers - Radar animation only
 * Disabled on mobile for performance
 */
function SpectrumVisualizers() {
  const radarSpec = (
    <g className="radar-sweep">
      <circle cx="100" cy="100" r="80" fill="none" stroke="currentColor" opacity="0.2" />
      <circle cx="100" cy="100" r="60" fill="none" stroke="currentColor" opacity="0.3" />
      <circle cx="100" cy="100" r="40" fill="none" stroke="currentColor" opacity="0.4" />
      <path d="M 100 100 L 180 100" stroke="currentColor" strokeWidth="2" opacity="0.6" />
    </g>
  );

  return (
    <svg className="radar" viewBox="0 0 200 200" preserveAspectRatio="xMidYMid slice">
      {radarSpec}
    </svg>
  );
}

export default SpectrumVisualizers;
